import script from "./ArticleStatusFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleStatusFilter.vue?vue&type=script&setup=true&lang=js"

import "./ArticleStatusFilter.vue?vue&type=style&index=0&id=6be7d2f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6be7d2f6"]])

export default __exports__